// extracted by mini-css-extract-plugin
module.exports = {"container":"_6501c300","pagetitle":"_445c58f3"};